import { WordSetType } from 'app/types';

const index = '';
const wordset = 'wordset';
const levelBased = `${wordset}/level-based`;
const topicRelated = `${wordset}/topic-related`;
const mostCommon = `${wordset}/most-common`;
const irregularVerb = `${wordset}/irregular-verb`;
const wordSetCategoryOverview = `${wordset}/:wordSetType`;
const categoryOverview = `${wordSetCategoryOverview}/:categoryName`;
const subCategoryOverview = `${categoryOverview}/:subcategoryName`;
const vocabulary = `vocabulary`;
const vocabularyWords = `vocabulary/words`;
const vocabularyWordsPage = `${vocabularyWords}/page/:vocabularyPage`;
const vocabularyExpressions = `vocabulary/expressions`;
const vocabularyExpressionsPage = `${vocabularyExpressions}/page/:vocabularyPage`;
const vocabularyVerbs = `vocabulary/irregular-verbs`;
const vocabularyExport = `vocabulary/export`;
const vocabularyImport = `vocabulary/import`;
const vocabularyTest = `test-my-vocabulary`;
const vocabularyTestRun = `${vocabularyTest}/run`;
const vocabularyTestResult = `${vocabularyTest}/result/:vocabularyTestResultId`;
const learning = `exercises`;
const learningSession = `${learning}/:learningSessionId`;
const inAction = `in-action`;
const inActionList = `${inAction}/:inActionListId`;
const community = `community`;
const communityInActionSets = `${community}/in-action-sets`;
const profile = `profile`;
const achievements = `achievements`;
const feedbackIdeas = 'feedback/ideas';
const feedbackMine = 'feedback/mine';
const adminFeedback = 'admin/feedback';

// fills url with dynamic ids e.g`/:param1/:param2` with { param1: value1, param2: value2 }
export const fillUrlIds = (
  url: string,
  record: {
    categoryName?: string;
    subcategoryName?: string;
    wordSetType?: WordSetType;
    learningSessionId?: string;
    inActionListId?: string;
    vocabularyPage?: string;
    vocabularyTestResultId?: string;
  },
) =>
  '/' +
  url
    .split('/')
    .map((urlSegment) =>
      // fill dynamic id with value
      urlSegment[0] === ':'
        ? record[urlSegment.slice(1) as keyof typeof record]
        : urlSegment,
    )
    .join('/');

// find that path like /foo/bar fits for /foo/:id
export const isPathEqualToRoute = (path: string, route: string) => {
  const pathSplit = path.split('/');
  const routeSplit = route.split('/');

  return (
    pathSplit.length === routeSplit.length &&
    pathSplit.every((segment, index) => {
      const routeSegment = routeSplit[index];

      return (
        routeSegment !== undefined &&
        (routeSegment[0] !== ':' ? segment === routeSegment : true)
      );
    })
  );
};

export const pagePaths = {
  index,
  wordset,
  levelBased,
  topicRelated,
  mostCommon,
  irregularVerb,
  wordSetCategoryOverview,
  categoryOverview,
  subCategoryOverview,
  vocabulary,
  vocabularyWords,
  vocabularyWordsPage,
  vocabularyExpressions,
  vocabularyExpressionsPage,
  vocabularyVerbs,
  vocabularyExport,
  vocabularyImport,
  vocabularyTest,
  vocabularyTestRun,
  vocabularyTestResult,
  learning,
  learningSession,
  inAction,
  inActionList,
  community,
  communityInActionSets,
  profile,
  achievements,
  feedbackIdeas,
  feedbackMine,
  adminFeedback,
};
